import PropTypes from 'prop-types';
import React, { Component } from 'react';
import _get from 'lodash/get';
import queryString from 'query-string';

import { Container, Divider, Typography } from 'ravenjs';
import { DOWNLOAD_DOC } from 'utils/constants';

class Success extends Component {
    static propTypes = {
        history : PropTypes.object.isRequired,
        location: PropTypes.object.isRequired
    };

    componentDidMount() {
        const { history, location } = this.props;
        const search = queryString.parse(location.search);
        const token = _get(search, 'token');
        // We don't want the user to access the route unless they've
        // previously signed a handbook.
        if (!token) {
            history.replace('/');
        }
    }

    render() {
        return (
            <Container margin="25px auto" padding="0 25px">
                <Typography fullWidth type="title">
                    Done!
                </Typography>
                <Divider />
                <Typography fullWidth>
                    {DOWNLOAD_DOC}
                </Typography>
            </Container>
        );
    }
}

export default Success;
